module.exports = __webpack_public_path__ + "static/about-us-hero-image-7d507d27eef6e6a0b7ed44b0cb878938.jpg";